import { useAuth } from "@/contexts/AuthContext";
import { usePoppedConversations } from "@/contexts/PoppedConversationsContext";
import { PoppedConversationWindow } from "./PoppedConversationWindow";

export const PoppedConversationsDock = () => {
  const { user } = useAuth();
  const { popped } = usePoppedConversations();
  if (!user || popped.length === 0) return null;
  return (
    <div className="fixed bottom-0 right-4 z-40 flex items-end gap-3 pointer-events-none">
      {popped.map((p) => (
        <PoppedConversationWindow
          key={p.id}
          id={p.id}
          partnerName={p.partnerName}
          partnerAvatar={p.partnerAvatar}
          minimized={p.minimized}
        />
      ))}
    </div>
  );
};
